import { useEffect, useState } from "react";
import moment from 'moment'
import { getOverallPerformance, getOverallPerformanceAggregate } from "@/pages/dashboard/services/monetization";
import { useLocal } from "@/pages/dashboard/utils/customHook";
import { formatAccumulation, formatFilterValues } from '@/pages/dashboard/utils/utils'

/**
 * 按照接口区分为不同model
 * hook名称规范：use+接口名称+Data
 * @param props 父页面所有props
 * @param props: timeZone 时区信息，realtime特有
 * @param props: dispatch dva  dispatch方法
 * @returns 
 * 获取数据的逻辑：dva中有数据则取dva中的数据，否则自己通过接口请求
 */

const useRevenueOverallPaymentModel = (props: any, formValue: any, dispatch: any, filterLoading: boolean, accumulated: string[], paging: {}, sorts: [], period: string, filterConfirm: boolean) => {
    const { gameCode } = props;
    const { isEN } = useLocal();
    const [componentData, setComponentData] = useState({
        aggregation: null,
        average: null,
        metrics_list: [],
        page: 1,
        page_size: 10,
        row_count: 0,
    });
    const [aggregateData, setAggregateData] = useState({
        aggregation: null,
        average: null,
        metrics_list: [],
        page: 1,
        page_size: 10,
        row_count: 0,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    // 点击筛选器的时候
    useEffect(() => {
        if (!formValue) return;
        !filterLoading && getRevenueOverallPaymentFunc()
    }, [formValue, paging, sorts])

    const getRevenueOverallPaymentFunc = () => {
        const { filterValue } = formValue
        const { rangeTime, ...filters } = filterValue
        const params = {
            period,
            accumulation: formatAccumulation(accumulated),
            game_code: gameCode,
            filters: formatFilterValues(filters),
            start_date: moment(rangeTime?.[0]).format('YYYYMMDD') || '',
            end_date: moment(rangeTime?.[1]).format('YYYYMMDD') || '',
            page: filterConfirm ? 1 : paging?.pageIndex,
            page_size: filterConfirm ? 10 : paging?.pageSize,
            sorted_by: sorts?.[0] ? sorts[0].by : 'date',
            desc: sorts?.[0] ? sorts[0].order === 'desc' : true
        }
        setLoading(true);
        getOverallPerformance(params, isEN ? 'en' : 'zh').then((result: any) => {
            // setLoading(false);
            // setError(false)
            setComponentData(result);
            dispatch({
                type: "engagementServiceData/getRevenueOverallPaymentFunc",
                payload: {
                    result
                }
            });
            // 处理Sum Avarage
            const { pageSize, pageIndex } = filterConfirm ? {pageIndex: 1, pageSize: 10} : paging;
            const { row_count } = result || {};
            const isLast = !!row_count && pageIndex === Math.ceil(row_count / (pageSize ?? 0));
            if (isLast) {
                params.page = 1
                getOverallPerformanceAggregate(params).then(_res => {
                    setAggregateData(_res)
                    setLoading(false);
                    setError(false)
                });
            } else {
                setAggregateData({
                    aggregation: null,
                    average: null,
                    metrics_list: [],
                    page: 1,
                    page_size: 10,
                    row_count: 0,
                })
            }
            setLoading(false);
            setError(false)
        }).catch((err: any) => {
            setError(true)
            setLoading(false);
        })
    }
    return {
        aggregateData,
        // nodata 不在此封装，因为可能是接口的个别项目nodata
        componentData,
        loading,
        error,
    }
}

export default useRevenueOverallPaymentModel;